import type { PropsWithChildren } from 'react'

export const ErrorText = ({ children }: PropsWithChildren) => {
  return <p className="mt-2 text-xs text-danger-default">{children}</p>
}
